import axios from 'axios';
import store from '@/store';

const $http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URI_API,
    responseType: 'json',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
 });

$http.interceptors.response.use(
    (config: any) => config,
    (err: any) => {
        if (err.response && err.response.status === 403) {
            store.dispatch('authLogout');
        }
        return Promise.reject(err);
    },
);

export default $http;
